import {
  Directive,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';

@Directive({
  selector: '[lazyLoad]'
})
export class LazyLoadDirective implements OnInit, OnDestroy {

  @Output() visible = new EventEmitter<void>();
  private observer!: IntersectionObserver;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.observer = new IntersectionObserver(
  ([entry]) => {
    if (entry.isIntersecting) {
      this.visible.emit();
      this.observer.disconnect();
    }
  },
  {
    threshold: 1.0,        // 🔥 fully visible
    rootMargin: '600px 0px'
  }
);


    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
